module.exports = __webpack_public_path__ + "img/releaseTwo.6161becd.jpg";